export enum PlayStoreChart {
	"FREE" = "FREE",
	"PAID" = "PAID",
	"GROSSING" = "GROSSING",
}
